import styled, { css } from 'styled-components';
import { TappingOptionButtonState } from '.';

export const Button = styled.button<{
  $label: string | null;
  $buttonState: TappingOptionButtonState;
  $used: boolean;
  $showBigger: boolean;
  $onVideo?: boolean;
}>(
  ({ theme, $label, $buttonState, $used, $showBigger, $onVideo }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    min-width: ${theme.sz.s24};
    min-height: ${theme.sz.s12};
    font-size: ${$showBigger ? theme.DEPRECATED_ty.largest : theme.DEPRECATED_ty.larger};
    border-radius: ${theme.sz.s4};
    padding: ${$showBigger ? `${theme.sz.s1} ${theme.sz.s8}` : `0 ${theme.sz.s8}`};
    font-weight: ${$showBigger ? theme.DEPRECATED_ty.semiBold : theme.DEPRECATED_ty.medium};
    outline: 0;
    border: ${theme.bo.mediumWidth} solid
      ${
        $used
          ? theme.co.secondary80
          : $buttonState === 'green'
            ? theme.co.success40
            : $buttonState === 'orange'
              ? theme.co.warning20
              : $buttonState === 'red'
                ? theme.co.error40
                : theme.co.secondary80
      };
    background-color: ${
      $used
        ? theme.co.secondary80
        : $buttonState === 'green'
          ? theme.co.success80
          : $buttonState === 'orange'
            ? theme.co.warning80
            : $buttonState === 'red'
              ? theme.co.error80
              : $onVideo
                ? theme.co.neutral99
                : 'transparent'
    };
    color: ${
      $used
        ? theme.co.secondary80
        : $buttonState === 'green'
          ? theme.co.success0
          : $buttonState === 'orange'
            ? theme.co.warning0
            : $buttonState === 'red'
              ? theme.co.error20
              : theme.co.secondary20
    };
    box-shadow: 0 4px 0
      ${
        $used
          ? theme.co.secondary80
          : $buttonState === 'green'
            ? theme.co.success40
            : $buttonState === 'orange'
              ? theme.co.warning20
              : $buttonState === 'red'
                ? theme.co.error40
                : theme.co.secondary80
      };
    z-index: ${theme.zi.z2};
    &:before {
      content: '${$label}';
      position: absolute;
      display: ${
        $used || $label === null || !['default', 'yellow'].includes($buttonState) ? 'none' : 'flex'
      };
      justify-content: center;
      align-items: center;
      left: ${theme.sz.s2};
      top: ${theme.sz.s2};
      box-sizing: border-box;
      padding: 0 ${theme.sz.s05};
      min-width: ${theme.sz.s4};
      height: ${theme.sz.s4};
      border-radius: ${theme.sz.s1};
      font-size: ${theme.DEPRECATED_ty.small};
      line-height: ${theme.DEPRECATED_ty.small};
      color: ${theme.co.primary99};
      background-color: ${theme.co.neutral20};
    }
    &:not([disabled]):hover {
      box-shadow: 0 6px 0
        ${
          $used
            ? 'none'
            : $buttonState === 'green'
              ? theme.co.success40
              : $buttonState === 'orange'
                ? theme.co.warning20
                : $buttonState === 'red'
                  ? theme.co.error40
                  : theme.co.secondary80
        };
      transform: translateY(${$used ? '0' : '-2px'});

      /* This is to avoid flickering when placing the cursor at the bottom, ca$used by the transform */
      &::after {
        content: '';
        width: 100%;
        position: absolute;
        top: 100%;
        height: 6px;
      }
    }
    &:disabled {
      opacity: ${$used ? 1 : 0.6};
      cursor: not-allowed;
    }
  `,
);
